"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledEmptyMessage = exports.StyledTableContainer = void 0;
const react_1 = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
const LinearProgress_1 = require("../LinearProgress/LinearProgress");
// Import Table Components
const TableHeader_1 = __importDefault(require("./TableHeader"));
const TableRow_1 = __importDefault(require("./TableRow"));
const PaginationFooter_1 = __importDefault(require("./PaginationFooter"));
const react_to_print_1 = require("react-to-print");
const utils_1 = require("./utils");
exports.StyledTableContainer = Theme_1.styled.table `
  border-collapse: collapse;
  width: 100%;
  > thead > div {
    position: absolute;
    margin-top: -3px;
  }
`;
exports.StyledEmptyMessage = Theme_1.styled.div `
  text-align: center;
  font-size: 24pt;
  font-weight: 300;
  font-family: proxima-nova, sans-serif;
  color: ${(props) => props.theme.colors.gray[70]};
  border: 1px solid ${(props) => props.theme.colors.gray[30]};
  border-top: none;
  padding: 40px 0;
`;
const StyledFooterContainer = Theme_1.styled.div `
  border: 1px solid ${(props) => props.theme.colors.gray[30]};
  border-top: none;
  background-color: ${(props) => props.theme.white};
`;
const SmrTable = react_1.default.forwardRef((props, ref) => {
    var _a;
    const { columns, footerOptions, rows, emptyMessage, sortingOptions, loading, } = props;
    const [currentPage, setCurrentPage] = (0, react_1.useState)((_a = footerOptions === null || footerOptions === void 0 ? void 0 : footerOptions.page) !== null && _a !== void 0 ? _a : 1);
    const [rowsPerPage, setRowsPerPage] = (0, react_1.useState)((footerOptions === null || footerOptions === void 0 ? void 0 : footerOptions.rowsPerPage) || 10);
    const contentRef = (0, react_1.useRef)(null);
    const handlePrint = (0, react_to_print_1.useReactToPrint)({
        content: () => contentRef.current,
    });
    react_1.default.useImperativeHandle(ref, () => ({
        exportSpreadsheet: (options) => {
            (0, utils_1.exportSpreadsheet)(rows, columns, options);
        },
        printTable: (options) => {
            if (options === null || options === void 0 ? void 0 : options.printAllRows) {
                const originalPage = currentPage;
                const currentRowsPerPage = rowsPerPage;
                setCurrentPage(1);
                setRowsPerPage(rows.length);
                setTimeout(() => {
                    handlePrint();
                    setRowsPerPage(currentRowsPerPage);
                    setCurrentPage(originalPage);
                });
            }
            else {
                handlePrint();
            }
        },
        setRowsPerPage: (newRowsPerPage) => {
            setRowsPerPage(newRowsPerPage);
        },
        rowsPerPage,
        setCurrentPage: (newCurrentPage) => {
            setCurrentPage(newCurrentPage);
        },
        currentPage,
    }));
    (0, react_1.useEffect)(() => {
        if (Math.ceil(rows.length / rowsPerPage) < currentPage) {
            setCurrentPage(1);
        }
    }, [rows.length]);
    const firstRender = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        setCurrentPage(1);
    }, [rowsPerPage]);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedRows = rows.slice(startIndex, endIndex);
    return (react_1.default.createElement("div", { ref: contentRef, style: { transform: 'scale(1)' } },
        react_1.default.createElement(exports.StyledTableContainer, null,
            react_1.default.createElement("thead", null,
                react_1.default.createElement(TableHeader_1.default, { columns: columns, sortColumn: sortingOptions === null || sortingOptions === void 0 ? void 0 : sortingOptions.onSort, sortedColumnIndex: sortingOptions === null || sortingOptions === void 0 ? void 0 : sortingOptions.sortedColumnIndex, sortDirection: sortingOptions === null || sortingOptions === void 0 ? void 0 : sortingOptions.sortDirection }),
                loading && react_1.default.createElement(LinearProgress_1.LinearProgress, null)),
            react_1.default.createElement("tbody", null, rows.length > 0 &&
                paginatedRows.map((row, index) => (react_1.default.createElement(TableRow_1.default, { key: index, columns: columns, cells: row.cells, onClick: row.onClick, sortedColumnIndex: sortingOptions === null || sortingOptions === void 0 ? void 0 : sortingOptions.sortedColumnIndex, sortDirection: sortingOptions === null || sortingOptions === void 0 ? void 0 : sortingOptions.sortDirection }))))),
        rows.length === 0 && !loading && (react_1.default.createElement(exports.StyledEmptyMessage, null, emptyMessage || 'No data.')),
        react_1.default.createElement(StyledFooterContainer, null,
            react_1.default.createElement(PaginationFooter_1.default, { currentPage: currentPage, rowsPerPage: rowsPerPage, customRowsPerPageOptions: footerOptions === null || footerOptions === void 0 ? void 0 : footerOptions.customRowsPerPageOptions, disabled: rows.length === 0, totalRows: rows.length, footerOptions: footerOptions, onChangePage: (page) => setCurrentPage(page), onChangeRowsPerPage: (rowAmount) => {
                    setRowsPerPage(rowAmount);
                }, loading: loading }))));
});
SmrTable.displayName = 'SmrTable';
exports.default = SmrTable;
//# sourceMappingURL=Table.js.map